/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-empty-function */

import React, { useCallback, useRef, useState, useEffect } from 'react';
import {
  Checkbox as CheckBoxMaterialUI,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputLabel,
  MenuItem,
  Select as SelectMaterialUI,
  Button as MaterialButton,
  FormControlLabel,
  Radio as RadioMaterialUI,
  RadioGroup,
  FormControl,
} from '@material-ui/core';

import { makeStyles } from '@mui/styles';
import Box from '@material-ui/core/Box';
import { Form } from '@unform/web';
import { Toolbar, Data } from 'react-data-grid-addons';
import { FiEdit, FiPlusCircle, FiTrash2, FiPlusSquare } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import DataGrid from 'react-data-grid';
import { Container, ContainerBox, ButtonTabs, Info, Tabela } from './styles';
import NavBar from '../../../components/NavBar';
import Header from '../../../components/Header';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../../components/Input';
import DataTimer from '../../../components/DataTimer';
import CheckBox from '../../../components/CheckBox';
import Radio from '../../../components/Radio';
import Select from '../../../components/Select';
import DialogInsumos from '../../../components/Insumos/DialogInsumos';
import { CdProdPaiContext } from '../../../contexts/CdProdPaiContext';
import { LocalProducao } from '../LocaisProducao';

export interface Produto {
  ativo: string;
  baixa: string;
  cd: string;
  cest: string;
  cfop: string;
  cfop_e: string;
  classe: string;
  cofins: string;
  cofins_e: string;
  cst: string;
  cst_cofins: string;
  cst_cofins_e: string;
  cst_e: string;
  cst_ipi: string;
  cst_ipi_e: string;
  cst_pis: string;
  cst_pis_e: string;
  dt_estoque: string;
  dt_ins: string;
  estoque: string;
  estoque_inicio_dia: string;
  estoque_min: string;
  exporta_bal: string;
  hash: string;
  iat: string;
  icms: string;
  icms_dec: string;
  icms_e: string;
  img: string;
  ipi: string;
  ipi_e: string;
  iprj: string;
  lista: string;
  local_producao: string;
  marca: string;
  mav_externo: string;
  mav_interno: string;
  modalidade_bc: string;
  ncm: string;
  ncm_ex: string;
  nm: string;
  per_lucro: string;
  pis: string;
  pis_e: string;
  pontos: string;
  preco_custo: string;
  preco_custo_att: string;
  produto_alcoolico: string;
  qtd: string;
  reducao_bc: string;
  servico: string;
  tempo_producao: string;
  tipo: string;
  unid: string;
  unid_emb: string;
  vendas: string;
  vl: string;
  validade: string;
  vl_calorico: string;
  carboidrato: string;
  proteinas: string;
  gorduras_totais: string;
  gorduras_saturadas: string;
  colesterol: string;
  fibra_alimentar: string;
  calcio: string;
  ferro: string;
  sodio: string;
  gordura_trans: string;
  acido_folico: string;
  porcao: string;
  ingredientes: string;
}
interface ClasseProd {
  id: number;
  nm: string;
  pai: string;
}
interface Marca {
  cd: number;
  nm: string;
  hash: string;
  cd_empresa: number;
}
interface Empresa {
  cd: string;
  nm: string;
  hash: string;
  cd_empresa: string;
  // preco: Preco;
}
interface Preco {
  cd_lista: string;
  valor: string;
  checked: boolean;
}
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    height: '60vh',
  },
});
const defaultColumnProperties = {
  resizable: true,
};

const selectors = Data.Selectors;
const columns = [
  {
    key: 'cd',
    name: 'CD',
    filterable: true,
    width: 60,
  },
  {
    key: 'nm',
    name: 'Nome',
    filterable: true,
    width: 250,
  },
  {
    key: 'vl',
    name: 'Valor',
    filterable: true,
  },
  {
    key: 'estoque',
    name: 'Estoque',
    filterable: true,
  },
  {
    key: 'unid',
    name: 'Unidade',
    filterable: true,
  },
  {
    key: 'estoque_min',
    name: 'Estoque Min',
    filterable: true,
  },
  {
    key: 'per_lucro',
    name: 'Lucro',
    filterable: true,
  },
  {
    key: 'icms',
    name: 'Situação Tri.',
    filterable: true,
  },
  {
    key: 'iat',
    name: 'IAT',
    filterable: true,
  },
  {
    key: 'baixa',
    name: 'Baixa Est.',
    filterable: true,
  },
  {
    key: 'acoes',
    name: 'Ações',
    filterable: false,
    width: 120,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));

const handleFilterChange = (filter: any) => (filters: any) => {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
};

function getRows(rows: any, filters: any) {
  return selectors.getRows({ rows, filters });
}
const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};

const Produtos: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const classes = useStyles();

  const [selectClasseFiscal, setSelectClasseFiscal] = useState('II');
  const [cadastrar, setCadastrar] = useState(true);

  const { addToast } = useToast();

  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [tabsGeral, setTabsGeral] = useState(true);
  const [tabsBalanca, setTabsBalanca] = useState(false);
  const [tabsDetalhes, setTabsDetalhes] = useState(false);
  const [tabsTributacao, setTabsTributacao] = useState(false);
  const [tabsNutricional, setTabsNutricional] = useState(false);
  const [tabsPrecos, setTabsPrecos] = useState(false);
  const [tabsInsumos, setTabsInsumos] = useState(false);

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openInsumos, setOpenInsumos] = useState(false);
  const [produtoDefault, setProdutoDefault] = useState<Produto>({
    ativo: 'S',
    baixa: 'S',
    cd: '',
    nm: '',
    unid: 'UN',
    iat: 'T',
    unid_emb: '',
    exporta_bal: '0',
    produto_alcoolico: '0',
    servico: '10',
    cest: '',
    cfop: '',
    cfop_e: '',
    classe: '',
    cofins: '',
    cofins_e: '',
    cst: '',
    cst_cofins: '',
    cst_cofins_e: '',
    cst_e: '',
    cst_ipi: '',
    cst_ipi_e: '',
    cst_pis: '',
    cst_pis_e: '',
    dt_estoque: '',
    dt_ins: '',
    estoque: '',
    estoque_inicio_dia: '',
    estoque_min: '',
    hash: '',
    icms: '',
    icms_dec: '',
    icms_e: '',
    img: '',
    ipi: '',
    ipi_e: '',
    iprj: '',
    lista: '',
    local_producao: '',
    marca: '',
    mav_externo: '',
    mav_interno: '',
    modalidade_bc: '',
    ncm: '',
    ncm_ex: '',
    per_lucro: '',
    pis: '',
    pis_e: '',
    pontos: '',
    preco_custo: '',
    preco_custo_att: '',
    qtd: '',
    reducao_bc: '',
    tempo_producao: '00:00',
    tipo: '',
    vendas: '',
    vl: '',
    validade: '',
    vl_calorico: '',
    carboidrato: '',
    proteinas: '',
    gorduras_totais: '',
    gorduras_saturadas: '',
    colesterol: '',
    fibra_alimentar: '',
    calcio: '',
    ferro: '',
    sodio: '',
    gordura_trans: '',
    acido_folico: '',
    porcao: '',
    ingredientes: '',
  } as Produto);
  const [precos, setPrecos] = useState<Preco[]>([
    { cd_lista: '', valor: '', checked: true },
  ]);
  const [listaProdutos, setListaProdutos] = useState([] as any);
  const [listaClasses, setListaClasses] = useState([] as any);
  const [listaLocaisProducao, setListaLocaisProducao] = useState([] as any);
  const [listaMarcas, setListaMarcas] = useState([] as any);
  const [listaMarcasCd, setListaMarcasCd] = useState([] as any);
  const [listaEmpresas, setListaEmpresas] = useState([] as any);

  const [baixaAdicionais, setBaixaAdicionais] = React.useState('baixaSimples');
  const [filters, setFilters] = useState({});
  useEffect(() => {
    api
      .get<LocalProducao[]>('locais_producao')
      .then((response) => {
        const lista = response.data.map((local: LocalProducao) => local.nm);
        setListaLocaisProducao(lista);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar os locais de produção: ${error}`,
        });
      });
  }, [addToast]);
  useEffect(() => {
    api
      .get<ClasseProd[]>('classes')
      .then((response) => {
        const lista = response.data.map((classe: ClasseProd) => classe.nm);
        setListaClasses(lista);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar as classes: ${error}`,
        });
      });
  }, [addToast]);
  useEffect(() => {
    api
      .get<Marca[]>('produtos/marcas')
      .then((response) => {
        const lista = response.data.map((marca: Marca) => marca.nm);
        const listaCd = response.data.map((marca: Marca) => marca.cd);
        setListaMarcas(lista);
        setListaMarcasCd(listaCd);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar as classes: ${error}`,
        });
      });
  }, [addToast]);
  useEffect(() => {
    api
      .get<Empresa[]>('empresas')
      .then((response) => {
        const lista: Preco[] = [];

        response.data.forEach((empresa) => {
          const p: Preco = {
            cd_lista: empresa.cd,
            valor: '',
            checked: true,
          };
          lista.push(p);
        });

        setPrecos([...lista]);

        setListaEmpresas(response.data);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar as empresas: ${error}`,
        });
      });
  }, [addToast]);

  const filteredRows = getRows(listaProdutos, filters);
  const changeTabs = useCallback((tab: string) => {
    tab === 'geral' ? setTabsGeral(true) : setTabsGeral(false);
    tab === 'balanca' ? setTabsBalanca(true) : setTabsBalanca(false);
    tab === 'detalhes' ? setTabsDetalhes(true) : setTabsDetalhes(false);
    tab === 'tributacao' ? setTabsTributacao(true) : setTabsTributacao(false);
    tab === 'nutricional'
      ? setTabsNutricional(true)
      : setTabsNutricional(false);
    tab === 'precos' ? setTabsPrecos(true) : setTabsPrecos(false);
    tab === 'insumos' ? setTabsInsumos(true) : setTabsInsumos(false);
  }, []);
  const reloadPreco = useCallback(() => {
    const lista: Preco[] = [];

    listaEmpresas.forEach((empresa: Empresa) => {
      const p: Preco = { cd_lista: empresa.cd, valor: '', checked: true };
      lista.push(p);
    });

    setPrecos([...lista]);
  }, [listaEmpresas]);
  const handleClickOpen = useCallback(() => {
    changeTabs('geral');
    setBaixaAdicionais('baixaSimples');
    const p = {
      ativo: 'S',
      baixa: 'S',
      nm: '',
      unid: 'UN',
      iat: 'T',
      unid_emb: '',
      exporta_bal: '0',
      produto_alcoolico: '0',
      servico: '10',
      cd: '',
      cest: '',
      cfop: '',
      cfop_e: '',
      classe: '',
      cofins: '',
      cofins_e: '',
      cst: '',
      cst_cofins: '',
      cst_cofins_e: '',
      cst_e: '',
      cst_ipi: '',
      cst_ipi_e: '',
      cst_pis: '',
      cst_pis_e: '',
      dt_estoque: '',
      dt_ins: '',
      estoque: '',
      estoque_inicio_dia: '',
      estoque_min: '',
      hash: '',
      icms: '',
      icms_dec: '',
      icms_e: '',
      img: '',
      ipi: '',
      ipi_e: '',
      iprj: '',
      lista: '',
      local_producao: '',
      marca: '',
      mav_externo: '',
      mav_interno: '',
      modalidade_bc: '',
      ncm: '',
      ncm_ex: '',
      per_lucro: '',
      pis: '',
      pis_e: '',
      pontos: '',
      preco_custo: '',
      preco_custo_att: '',
      qtd: '',
      reducao_bc: '',
      tempo_producao: '00:00',
      tipo: '',
      vendas: '',
      vl: '',
      validade: '',
      vl_calorico: '',
      carboidrato: '',
      proteinas: '',
      gorduras_totais: '',
      gorduras_saturadas: '',
      colesterol: '',
      fibra_alimentar: '',
      calcio: '',
      ferro: '',
      sodio: '',
      gordura_trans: '',
      acido_folico: '',
      porcao: '',
      ingredientes: '',
    } as Produto;
    reloadPreco();
    setSelectClasseFiscal('II');
    setProdutoDefault(p);
    setCadastrar(true);
    setOpen(true);
  }, [changeTabs, reloadPreco]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleChangeClasseFiscal = useCallback((event) => {
    setSelectClasseFiscal(event.target.value);
  }, []);

  const handleCloseConfirmation = useCallback(() => {
    setOpenConfirmation(false);
  }, []);
  const changePreco = useCallback(
    (preco, empresa, index) => {
      setPrecos([
        ...precos.map((p, idx) => {
          if (index == idx) {
            // eslint-disable-next-line no-param-reassign

            p.valor = preco;
            // eslint-disable-next-line no-param-reassign
            p.cd_lista = empresa;
            return p;
          }
          return p;
        }),
      ]);
    },
    [precos],
  );
  const changePrecoCheckBox = useCallback(
    (checked, empresa, index) => {
      setPrecos([
        ...precos.map((p, idx) => {
          if (index == idx) {
            // eslint-disable-next-line no-param-reassign
            p.checked = checked != 'true';
            if (!p.checked) {
              p.valor = '';
            }
            // eslint-disable-next-line no-param-reassign
            p.cd_lista = empresa;
            return p;
          }
          return p;
        }),
      ]);
    },
    [precos],
  );

  const changeBaixaAdicionais = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setBaixaAdicionais((event.target as HTMLInputElement).value);
  };
  // eslint-disable-next-line no-return-assign
  const changeValueProduto = useCallback(
    (vl) => {
      produtoDefault.vl = vl;
      setPrecos([
        ...precos.map((preco) => {
          if (preco.checked) preco.valor = vl;
          return preco;
        }),
      ]);
      return produtoDefault;
    },
    [precos, produtoDefault],
  );
  const getPreco = useCallback(
    async (cd) => {
      try {
        const response = await api.get<Preco[]>(`produtos/preco/${cd}`);

        const listaCdPreco: string[] = [];

        const listaPreco: Preco[] = [];

        response.data.forEach((preco: Preco) => {
          listaCdPreco.push(preco.cd_lista);
        });
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < response.data.length; i++) {
          const p: Preco = {
            cd_lista: response.data[i].cd_lista,
            valor: response.data[i].valor,
            checked: true,
          };
          listaPreco.push(p);
        }
        listaEmpresas.forEach((empresa: Empresa) => {
          const cdPreco = listaCdPreco.includes(empresa.cd);
          if (!cdPreco) {
            const p: Preco = {
              cd_lista: empresa.cd,
              valor: '',
              checked: false,
            };
            listaPreco.push(p);
          }
        });

        listaPreco.sort((a, b) => {
          if (a.cd_lista > b.cd_lista) {
            return 1;
          }
          if (a.cd_lista < b.cd_lista) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        setPrecos([...listaPreco]);
        setOpen(true);
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar as empresas: ${error}`,
        });
      }
    },
    [addToast, listaEmpresas],
  );
  const getProduto = useCallback(
    async (cd) => {
      try {
        const response = await api.get<Produto[]>(`/produtos/${cd}`);
        setProdutoDefault({
          ...response.data[0],
          vl: response.data[0].vl.replace('.', ','),
          tempo_producao: response.data[0].tempo_producao.substring(0, 5),
        });
        if (response.data[0].icms === 'II') {
          setSelectClasseFiscal('II');
        } else if (response.data[0].icms === 'NN') {
          setSelectClasseFiscal('NN');
        } else if (response.data[0].icms === 'FF') {
          setSelectClasseFiscal('FF');
        } else {
          setSelectClasseFiscal('TT');
        }
        setCadastrar(false);
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar o produto: ${error}`,
        });
      }
    },
    [addToast],
  );
  const populaTabela = useCallback(() => {
    api
      .get<Produto[]>('produtos')
      .then((response) => {
        const itemsFormatted = [] as Array<any>;
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        response.data.forEach((produto) => {
          if (produto.icms == 'FF')
            itemsFormatted.push({
              ...produto,
              icms: 'Sub. Tributária',
              vl: formatter.format(parseFloat(produto.vl)),
            });
          else if (produto.icms == 'II')
            itemsFormatted.push({
              ...produto,
              icms: 'Isento',
              vl: formatter.format(parseFloat(produto.vl)),
            });
          else if (produto.icms == 'NN')
            itemsFormatted.push({
              ...produto,
              icms: 'Não Tributado',
              vl: formatter.format(parseFloat(produto.vl)),
            });
          else
            itemsFormatted.push({
              ...produto,
              icms: `${produto.icms},${produto.icms_dec}%`,
              vl: formatter.format(parseFloat(produto.vl)),
            });
        });
        setListaProdutos(itemsFormatted);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar os produtos: ${error}`,
        });
      });
  }, [addToast]);

  const deletaProduto = useCallback(() => {
    setDisabled(true);
    api
      .delete(`/produtos/${produtoDefault.cd}`)
      .then(() => {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: `O produto '${produtoDefault.nm}' foi deletado com sucesso.`,
        });
        populaTabela();
        handleCloseConfirmation();
        setDisabled(false);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ocorreu um erro ao tentar deletar o produto '${produtoDefault.nm}': '${error}'.`,
        });
        handleCloseConfirmation();
        setDisabled(false);
      });
  }, [addToast, produtoDefault, handleCloseConfirmation, populaTabela]);

  const handleSubmit = useCallback(
    async (data: Produto) => {
      setDisabled(true);

      try {
        const schema = Yup.object().shape({
          nm: Yup.string().required('Campo obrigatório'),
          vl: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cest: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'Mínimo valor.')
            .test('len', 'No máximo 7 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 7
                : val.toString().length <= 7;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cfop: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cfop_e: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cofins: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cofins_e: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst_cofins_e: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 2 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 2
                : val.toString().length <= 2;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst_e: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst_ipi: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 2 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 2
                : val.toString().length <= 2;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst_ipi_e: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 2 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 2
                : val.toString().length <= 2;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          cst_pis: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 2 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 2
                : val.toString().length <= 2;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          estoque_min: Yup.number()
            .integer('Digite apenas números inteiros')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 8 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 8
                : val.toString().length <= 8;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),

          icms: Yup.string().max(10, 'No máximo 10 caracteres.'),

          icms_e: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),

          ipi: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          ipi_e: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          iprj: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'Max 5 numbers', (val) => {
              return val === null || val === undefined
                ? 0 <= 5
                : val.toString().length <= 5;
            })
            // .test('len', 'Max 5 numbers', (val) =>val.toString().length <= 5)
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),

          mav_externo: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 5 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 5
                : val.toString().length <= 5;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          mav_interno: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 5 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 5
                : val.toString().length <= 5;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          modalidade_bc: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 2 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 2
                : val.toString().length <= 2;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          ncm: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 8 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 8
                : val.toString().length <= 8;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          per_lucro: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 8 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 8
                : val.toString().length <= 8;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          pis: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          pis_e: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 4 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 4
                : val.toString().length <= 4;
            })
            .nullable()
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          pontos: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 8 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 8
                : val.toString().length <= 8;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          preco_custo: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 8 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 8
                : val.toString().length <= 8;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          qtd: Yup.number()
            .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 9 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 9
                : val.toString().length <= 9;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          reducao_bc: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 7 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 7
                : val.toString().length <= 7;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          validade: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            .test('len', 'No máximo 11 caracteres', (val) => {
              return val === null || val === undefined
                ? 0 <= 7
                : val.toString().length <= 7;
            })
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          vl_calorico: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          carboidrato: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          proteinas: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          gorduras_totais: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          gorduras_saturadas: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          colesterol: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          fibra_alimentar: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          calcio: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          ferro: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          sodio: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          gordura_trans: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          acido_folico: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          porcao: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
          ingredientes: Yup.number()
            // .integer('Digite apenas números inteiros.')
            .typeError('Digite apenas números')
            // .min(0, 'No máximo 4 caracteres.')
            // .max(100, 'No máximo 4 caracteres.')
            .nullable()
            .transform((_, value) => {
              if (value.includes('.')) {
                return null;
              }
              return +value.replace(/,/, '.');
            })
            .transform((value: string, originalValue: string) =>
              originalValue.trim() === '' ? null : value,
            ),
        });
        formRef.current?.setErrors({});

        await schema.validate(data, {
          abortEarly: false,
        });
        if (cadastrar) {
          const response = await api.post('produtos', {
            ...data,
            precos: precos.filter((prec) => prec.checked == true),
          });

          if (response.status === 200) {
            populaTabela();
            handleClose();
            addToast({
              type: 'success',
              title: 'Sucesso',
              description: `O produto ${data.nm} foi cadastrada com sucesso.`,
            });
            setDisabled(false);
          }
        } else {
          // Editar classe selecionada
          const response = await api.put('produtos', {
            ...data,
            cd: produtoDefault.cd,
            precos,
          });
          if (response.status === 200) {
            populaTabela();
            handleClose();
            addToast({
              type: 'success',
              title: 'Sucesso',
              description: `O produto ${data.nm} foi editada com sucesso.`,
            });
            setDisabled(false);
          }
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          setDisabled(false);
          return;
        }
        handleClose();
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ocorreu um erro ao ${
            cadastrar ? 'cadastrar' : 'editar'
          } o produto. Verifique se já existe um produto com esse nome.`,
        });
        setDisabled(false);
      }
    },
    [cadastrar, precos, populaTabela, handleClose, addToast, produtoDefault],
  );
  const updatePreco = useCallback((index) => precos[index].valor, [precos]);
  const getCellActions = useCallback(
    (column: any, row: any) => {
      const cellActions: { [index: string]: any } = {
        acoes: [
          {
            icon: (
              <span className="remover">
                <FiTrash2 />
              </span>
            ),
            callback: async () => {
              await getProduto(row.cd);
              setOpenConfirmation(true);
            },
          },
          {
            icon: (
              <span className="edit">
                <FiEdit />
              </span>
            ),
            callback: async () => {
              changeTabs('geral');
              setBaixaAdicionais('baixaSimples');
              await getProduto(row.cd);
              await getPreco(row.cd);
            },
          },
          {
            icon: (
              <span className="adicionar">
                <FiPlusSquare />
              </span>
            ),
            callback: async () => {
              await getProduto(row.cd);
              setOpenInsumos(true);
            },
          },
        ],
      };
      return cellActions[column.key];
    },
    [getProduto, changeTabs, getPreco],
  );
  useEffect(() => {
    populaTabela();
  }, [populaTabela]);
  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />
        <Info>
          <div className="header">
            <h1>PRODUTOS</h1>
            <button type="button" onClick={handleClickOpen}>
              <FiPlusCircle size={24} />
              CADASTRAR
            </button>
          </div>
          <Tabela>
            <DataGrid
              columns={columns}
              rowGetter={(i) => filteredRows[i]}
              rowsCount={filteredRows.length}
              minHeight={400}
              toolbar={<Toolbar enableFilter filterRowsButtonText="Filtrar" />}
              onAddFilter={(filter) => setFilters(handleFilterChange(filter))}
              onClearFilters={() => setFilters({})}
              getCellActions={getCellActions}
              emptyRowsView={EmptyRowsView}
            />
          </Tabela>

          <Dialog
            open={open}
            fullWidth
            maxWidth={tabsInsumos ? 'lg' : 'sm'}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {cadastrar ? 'Cadastrar' : 'Editar'} produto
              <div>
                <ButtonTabs
                  isFocused={tabsGeral}
                  onClick={() => changeTabs('geral')}
                  type="button"
                >
                  Geral
                </ButtonTabs>
                <ButtonTabs
                  isFocused={tabsBalanca}
                  onClick={() => changeTabs('balanca')}
                  type="button"
                >
                  Balança
                </ButtonTabs>
                <ButtonTabs
                  isFocused={tabsDetalhes}
                  onClick={() => changeTabs('detalhes')}
                  type="button"
                >
                  Detalhes
                </ButtonTabs>
                <ButtonTabs
                  isFocused={tabsTributacao}
                  onClick={() => changeTabs('tributacao')}
                  type="button"
                >
                  Tributação
                </ButtonTabs>
                <ButtonTabs
                  isFocused={tabsNutricional}
                  onClick={() => changeTabs('nutricional')}
                  type="button"
                >
                  Nutricional
                </ButtonTabs>
                <ButtonTabs
                  isFocused={tabsPrecos}
                  onClick={() => changeTabs('precos')}
                  type="button"
                >
                  Preços
                </ButtonTabs>
                <ButtonTabs
                  style={{
                    visibility:
                      baixaAdicionais == 'baixaComposta' ? 'visible' : 'hidden',
                  }}
                  isFocused={tabsInsumos}
                  onClick={() => changeTabs('insumos')}
                  type="button"
                >
                  Insumos
                </ButtonTabs>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className={classes.root}>
                <Form
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  id="formulario"
                  ref={formRef}
                  onSubmit={handleSubmit}
                >
                  <Box
                    display={tabsGeral ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Nome da Produto *
                        </InputLabel>
                        <Input
                          name="nm"
                          style={{ width: '250px' }}
                          placeholder="Nome do produto"
                          defaultValue={produtoDefault.nm}
                          autoFocus
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <Select
                          name="classe"
                          title="Classe :"
                          valorDefault={produtoDefault.classe}
                          label={listaClasses}
                          valor={listaClasses}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <Select
                          name="local_producao"
                          title="Local de Produção :"
                          valorDefault={produtoDefault.local_producao}
                          label={listaLocaisProducao}
                          valor={listaLocaisProducao}
                        />
                      </div>

                      <div>
                        <CheckBox
                          name="ativo"
                          valor={
                            produtoDefault.ativo === 'S'
                              ? ['S', 'N']
                              : ['N', 'S']
                          }
                          valueDefault={produtoDefault.ativo === 'S'}
                          label="Ativo"
                        />
                      </div>

                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Valor de venda
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="vl"
                          placeholder="Valor de venda"
                          defaultValue={produtoDefault.vl}
                          onChange={(e) => changeValueProduto(e.target.value)}
                        />
                      </div>

                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Estoque mínimo
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="estoque_min"
                          placeholder="Estoque mínimo"
                          defaultValue={produtoDefault.estoque_min}
                        />
                      </div>
                      <div>
                        <Select
                          name="unid"
                          valorDefault={produtoDefault.unid}
                          label={[
                            'UN (Unitário)',
                            'kg (Quilo)',
                            'g (Grama)',
                            'L (Litro)',
                            'ml (Mililitro)',
                            'm (Metro)',
                            'm² (Metro Quadrado)',
                            'm³ (Metro Cúbico)',
                            'cm (Centímetro )',
                            'R$ (Monetário)',
                            'FR (Fracionável)',
                            'SE (Serviço)',
                            'h (Hora)',
                          ]}
                          valor={[
                            'UN',
                            'kg',
                            'g',
                            'L',
                            'ml',
                            'm',
                            'm2',
                            'm3',
                            'cm',
                            'R$',
                            'FR',
                            'SE',
                            'h',
                          ]}
                          title="Unidade:"
                        />
                      </div>

                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Preço de custo
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="preco_custo"
                          placeholder="Preço de custo"
                          defaultValue={produtoDefault.preco_custo}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Lucro
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="per_lucro"
                          placeholder="Lucro"
                          defaultValue={produtoDefault.per_lucro}
                        />
                      </div>

                      <div>
                        <Select
                          name="iat"
                          valorDefault={produtoDefault.iat}
                          label={['Truncamento', 'Arredondamento']}
                          valor={['T', 'A']}
                          title="IAT:"
                        />
                      </div>
                    </div>
                  </Box>
                  <Box
                    display={tabsBalanca ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                      }}
                    >
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-label="gender"
                          name="gender1"
                          value={baixaAdicionais}
                          onChange={changeBaixaAdicionais}
                        >
                          <FormControlLabel
                            value="baixaSimples"
                            control={<RadioMaterialUI />}
                            label="Baixa Simples"
                          />
                          <FormControlLabel
                            value="baixaComposta"
                            control={<RadioMaterialUI />}
                            label="Baixa Composta"
                          />
                          <FormControlLabel
                            value="naoControlaEstoque"
                            control={<RadioMaterialUI />}
                            label="Não controla estoque"
                          />
                        </RadioGroup>
                      </FormControl>
                      {/*                     <InputLabel
                        id="select-label"
                        style={{ marginBottom: '4px', marginLeft: '2px' }}
                      >
                        Insumo
                      </InputLabel>
                      <FormControl>
                        <RadioMaterialUI
                          value={selectClasseFiscal}
                          onChange={handleChangeClasseFiscal}
                          displayEmpty
                          style={{ minWidth: '250px' }}
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          <MenuItem value="II">
                            <em> Isento </em>
                          </MenuItem>
                          <MenuItem value="TT">
                            <em> Tributado </em>
                          </MenuItem>
                          <MenuItem value="NN">
                            <em> Não Tributado </em>
                          </MenuItem>
                          <MenuItem value="FF">
                            <em> Subs. Tributária </em>
                          </MenuItem>
                        </RadioMaterialUI>
                      </FormControl> */}
                      <div>
                        <CheckBox
                          name="exporta_bal"
                          valor={
                            produtoDefault.exporta_bal === '0'
                              ? ['0', '1']
                              : ['1', '0']
                          }
                          valueDefault={produtoDefault.exporta_bal === '1'}
                          label="Exporta Bal"
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Qtd. Embalada
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="qtd"
                          placeholder="Qtd. Embalada"
                          defaultValue={produtoDefault.qtd}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <Select
                          name="unid_emb"
                          valorDefault={produtoDefault.unid_emb}
                          label={[
                            'unidade',
                            'quilo',
                            'grama',
                            'litro',
                            'mililitro',
                            'metro',
                            'centímetro',
                          ]}
                          valor={[
                            'unidade',
                            'quilo',
                            'grama',
                            'litro',
                            'mililitro',
                            'metro',
                            'centimetro',
                          ]}
                          title="Unid.Embalada:"
                        />
                      </div>
                    </div>
                  </Box>
                  <Box
                    display={tabsDetalhes ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                      }}
                    >
                      <CheckBox
                        name="produto_alcoolico"
                        valor={
                          produtoDefault.produto_alcoolico === '0'
                            ? ['0', '1']
                            : ['1', '0']
                        }
                        valueDefault={produtoDefault.produto_alcoolico === '1'}
                        label="Produto Alcoólico"
                      />
                      <CheckBox
                        name="servico"
                        valor={
                          produtoDefault.servico === '10'
                            ? ['10', '0']
                            : ['0', '10']
                        }
                        valueDefault={produtoDefault.servico === '10'}
                        label="Serviço"
                      />

                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Tempo de Produção
                        </InputLabel>
                        <DataTimer
                          name="tempo_producao"
                          style={{ width: '150px' }}
                          defaultValue={produtoDefault.tempo_producao}
                        />
                        {/*                         <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Tempo de produção
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="tempo_producao"
                          placeholder="Tempo"
                          defaultValue={produtoDefault}
                        /> */}
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <Select
                          valorDefault={produtoDefault.marca}
                          name="marca"
                          label={listaMarcas}
                          valor={listaMarcasCd}
                          title="Marca:"
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Pontos Fidelidade
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="pontos"
                          placeholder="Pts Fidelidade"
                          defaultValue={produtoDefault.pontos}
                        />
                      </div>

                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          MAV Interno
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="mav_interno"
                          placeholder="MAV Interno"
                          defaultValue={produtoDefault.mav_interno}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          MAV Externo
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="mav_externo"
                          placeholder="MAV Externo"
                          defaultValue={produtoDefault.mav_externo}
                        />
                      </div>

                      <div style={{ width: '250px' }}>
                        <Radio
                          name="tipo"
                          label={[
                            'Compra e Venda',
                            'Venda (Produção Própria)',
                            'Consumo',
                          ]}
                          valor={['A', 'V', 'C']}
                          title="Tipo (IPPT) :"
                        />
                      </div>
                    </div>
                  </Box>
                  <Box
                    display={tabsTributacao ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          alignSelf: 'flex-start',
                          marginBottom: '5px',
                        }}
                      >
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          NCM:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="ncm"
                          placeholder="NCM"
                          defaultValue={produtoDefault.ncm}
                        />
                      </div>
                      <div
                        style={{
                          alignSelf: 'flex-start',
                          marginBottom: '5px',
                        }}
                      >
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota IRPJ:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="iprj"
                          placeholder="Aliquota IRPJ"
                          defaultValue={produtoDefault.iprj}
                        />
                      </div>
                      <div
                        style={{
                          alignSelf: 'flex-start',
                          marginBottom: '5px',
                        }}
                      >
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CEST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cest"
                          placeholder="CEST"
                          defaultValue={produtoDefault.cest}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        ICMS - ENTRADA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cst"
                          placeholder="CST"
                          defaultValue={produtoDefault.cst}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="icms_e"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.icms_e}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        ICMS - SAÍDA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cst_e"
                          placeholder="CST"
                          defaultValue={produtoDefault.cst_e}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Classe Fiscal
                        </InputLabel>
                        <FormControl>
                          <SelectMaterialUI
                            value={selectClasseFiscal}
                            onChange={handleChangeClasseFiscal}
                            displayEmpty
                            style={{ minWidth: '250px' }}
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value="II">
                              <em> Isento </em>
                            </MenuItem>
                            <MenuItem value="TT">
                              <em> Tributado </em>
                            </MenuItem>
                            <MenuItem value="NN">
                              <em> Não Tributado </em>
                            </MenuItem>
                            <MenuItem value="FF">
                              <em> Subs. Tributária </em>
                            </MenuItem>
                          </SelectMaterialUI>
                        </FormControl>

                        <div
                          style={{
                            display:
                              selectClasseFiscal == 'TT' ? 'block' : 'none',
                            alignSelf: 'flex-start',
                          }}
                        >
                          <InputLabel
                            id="select-label"
                            style={{ marginBottom: '4px', marginLeft: '2px' }}
                          >
                            Alíquota
                          </InputLabel>
                          <Input
                            style={{ width: '150px' }}
                            name="icms"
                            placeholder="ICMS"
                            defaultValue={
                              selectClasseFiscal == 'TT' &&
                              parseFloat(produtoDefault.icms)
                                ? produtoDefault.icms
                                : ''
                            }
                          />
                        </div>
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <Select
                          name="modalidade_bc"
                          valorDefault={produtoDefault.modalidade_bc}
                          label={[
                            '0 = margem valor agregado (%)',
                            '1 = pauta (valor)',
                            '2 = preço tabelado max. (valor)',
                            '3 = valor de operação',
                          ]}
                          valor={['0', '1', '2', '3']}
                          title="Modalidade BC:"
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Red.BC:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="reducao_bc"
                          placeholder="Red.BC"
                          defaultValue={produtoDefault.reducao_bc}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        IPI - ENTRADA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cst_ipi_e"
                          placeholder="CST"
                          defaultValue={produtoDefault.cst_ipi_e}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="ipi_e"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.ipi_e}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        IPI - SAÍDA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cst_ipi"
                          placeholder="CST"
                          defaultValue={produtoDefault.cst_ipi}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="ipi"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.ipi}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        PIS/COFINS - ENTRADA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cst_cofins_e"
                          placeholder="CST"
                          defaultValue={produtoDefault.cst_cofins_e}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota PIS:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="pis_e"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.pis_e}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota COFINS:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cofins_e"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.cofins_e}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        PIS/COFINS - SAÍDA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CST:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cstIcmsEntrada"
                          placeholder="CST"
                          defaultValue={produtoDefault.icms}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota PIS:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="pis"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.pis}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Aliquota COFINS:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cofins"
                          placeholder="Aliquota"
                          defaultValue={produtoDefault.cofins}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        CFOP - ENTRADA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CFOP:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cfop_e"
                          placeholder="CFOP"
                          defaultValue={produtoDefault.cfop_e}
                        />
                      </div>
                      <h3 style={{ padding: '10px', color: '#2c73e9' }}>
                        CFOP - SAÍDA
                      </h3>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          CFOP:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="cfop"
                          placeholder="CFOP"
                          defaultValue={produtoDefault.cfop}
                        />
                      </div>
                    </div>
                  </Box>
                  <Box
                    display={tabsNutricional ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Valor Calórico (Kcal)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="vl_calorico"
                          placeholder="Valor Calórico (Kcal)"
                          defaultValue={produtoDefault.vl_calorico}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Carboidratos (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="carboidrato"
                          placeholder="Carboidratos (g)"
                          defaultValue={produtoDefault.carboidrato}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Proteínas (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="proteinas"
                          placeholder="Proteínas (g)"
                          defaultValue={produtoDefault.proteinas}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Gorduras Totais (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="gorduras_totais"
                          placeholder="Gorduras Totais (g)"
                          defaultValue={produtoDefault.gorduras_totais}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Gorduras Saturadas (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="gorduras_saturadas"
                          placeholder="Gorduras Saturadas (g)"
                          defaultValue={produtoDefault.gorduras_saturadas}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Gorduras Trans (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="gordura_trans"
                          placeholder="Gorduras Trans (g)"
                          defaultValue={produtoDefault.gordura_trans}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Colesterol (mg)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="colesterol"
                          placeholder="Colesterol (mg)"
                          defaultValue={produtoDefault.colesterol}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Fibra Alimentar (g)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="fibra_alimentar"
                          placeholder="Fibra Alimentar (g)"
                          defaultValue={produtoDefault.fibra_alimentar}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Cálcio (mg)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="calcio"
                          placeholder="Cálcio (mg)"
                          defaultValue={produtoDefault.calcio}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Ferro (mg)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="ferro"
                          placeholder="Ferro (mg)"
                          defaultValue={produtoDefault.ferro}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Ácido Fólico (ug)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="acido_folico"
                          placeholder="Ácido Fólico (ug)"
                          defaultValue={produtoDefault.acido_folico}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Sódio (mg)
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="sodio"
                          placeholder="Sódio (mg)"
                          defaultValue={produtoDefault.sodio}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Validade em dias:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="validade"
                          placeholder="Validade em dias:"
                          defaultValue={produtoDefault.validade}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Porção de:
                        </InputLabel>
                        <Input
                          style={{ width: '150px' }}
                          name="porcao"
                          placeholder="Porção"
                          defaultValue={produtoDefault.porcao}
                        />
                      </div>
                      <div style={{ alignSelf: 'flex-start' }}>
                        <InputLabel
                          id="select-label"
                          style={{ marginBottom: '4px', marginLeft: '2px' }}
                        >
                          Ingredientes
                        </InputLabel>
                        <Input
                          style={{
                            width: '260px',
                          }}
                          name="ingredientes"
                          placeholder="Ingredientes"
                          defaultValue={produtoDefault.ingredientes}
                        />
                      </div>
                    </div>
                  </Box>
                  <Box
                    display={tabsPrecos ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        flexWrap: 'wrap',
                      }}
                    >
                      {listaEmpresas.length > 0
                        ? listaEmpresas.map(
                            (empresa: Empresa, index: number) => (
                              <div
                                style={{
                                  alignSelf: 'flex-start',
                                }}
                                key={empresa.cd}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <CheckBoxMaterialUI
                                    value={precos[index].checked}
                                    onChange={(e) =>
                                      changePrecoCheckBox(
                                        e.target.value,
                                        empresa.cd,
                                        index,
                                      )
                                    }
                                    checked={precos[index].checked}
                                  />

                                  <InputLabel
                                    id="select-label"
                                    style={{
                                      marginBottom: '4px',
                                      marginLeft: '2px',
                                    }}
                                  >
                                    {empresa.nm}
                                  </InputLabel>
                                </div>

                                <Input
                                  style={{ width: '150px' }}
                                  name="preco"
                                  type="number"
                                  disabled={!precos[index].checked}
                                  placeholder="Preço"
                                  value={updatePreco(index)}
                                  onChange={(e) =>
                                    changePreco(
                                      e.target.value,
                                      empresa.cd,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            ),
                          )
                        : ''}
                    </div>
                  </Box>
                  {/*                   <Box
                    display={tabsInsumos ? 'flex' : 'none'}
                    flexWrap="wrap"
                    component="div"
                  >
                    {tabsInsumos && <TabInsumos />}
                  </Box> */}
                </Form>
              </div>
            </DialogContent>
            <DialogActions>
              <MaterialButton onClick={handleClose} color="primary">
                Cancelar
              </MaterialButton>
              <MaterialButton
                type="submit"
                form="formulario"
                disabled={disabled}
                color="primary"
              >
                {cadastrar ? 'Cadastrar' : 'Editar'} produto
              </MaterialButton>
            </DialogActions>
          </Dialog>
          <CdProdPaiContext.Provider value={{ cd_prod_pai: produtoDefault.cd }}>
            {openInsumos && (
              <DialogInsumos
                openInsumo={openInsumos}
                setOpen={setOpenInsumos}
              />
            )}
          </CdProdPaiContext.Provider>
          <Dialog
            open={openConfirmation}
            onClose={handleCloseConfirmation}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Atenção!</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Tem certeza que deseja deletar o produto &apos;
                {produtoDefault.nm}&apos;?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MaterialButton
                onClick={handleCloseConfirmation}
                style={{
                  color: '#2c73e9',
                }}
              >
                CANCELAR
              </MaterialButton>
              <MaterialButton
                onClick={deletaProduto}
                disabled={disabled}
                style={{
                  color: '#2c73e9',
                }}
              >
                DELETAR
              </MaterialButton>
            </DialogActions>
          </Dialog>
        </Info>
      </div>
    </Container>
  );
};

export default Produtos;
